import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16.5 12.019a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m0 0c0 1.656 1.007 3 2.25 3s2.25-1.344 2.25-3a9 9 0 1 0-2.636 6.364M16.5 12.019v-3.75"
    }, null, -1)
  ])))
}
export default { render: render }